export default defineNuxtPlugin(() => {
  const { configOptimizelyWebExperiments } = useFeatureFlags()
  const { optimizelySnippetId } = useRuntimeConfig().public

  if (isClient()) {
    const userId = useCookie('optimizelyUserId', {
      maxAge: 60 * 60 * 24 * 365
    })
    const optimizelyVisitNumber = useCookie('optimizelyVisitNumber', {
      default: () => 0,
      encode: (value) => String(value),
      decode: (value) => Number(value),
      maxAge: 60 * 60 * 24 * 90
    })
    // Session cookie to track if the user is currently active in the session
    const optimizelyActiveVisit = useCookie('optimizelyActiveVisit', {
      default: () => undefined,
      encode: (value) => String(value), // true → "true"
      decode: (value) => value === 'true',
    })

    if (!optimizelyActiveVisit.value) {
      optimizelyVisitNumber.value++
      optimizelyActiveVisit.value = true
    }

    userId.value ??= uuid()
  }

  if (configOptimizelyWebExperiments.enabled && optimizelySnippetId) {
    const snippetUrl = `https://cdn.optimizely.com/js/${optimizelySnippetId}.js`

    useHead({
      link: [
        { href: snippetUrl, rel: 'preload', as: 'script', tagPriority: 20 },
        { href: 'https://logx.optimizely.com', rel: 'preconnect', tagPriority: 'high' }
      ],
      script: [
        {
          id: 'optimizely-snippet',
          src: snippetUrl,
          tagPriority: 20,
          fetchpriority: 'high',
          async: configOptimizelyWebExperiments.async,
          defer: false,
          onerror: (err) => {
            console.warn('failed to load Optimzely snippet', err)
          }
        }
      ]
    })
    if (isClient()) {
      window.optimizely = window.optimizely || []
      window.optimizely.push({
        type: 'activate'
      })
    }
  }
})
